import { Components, Theme } from '@mui/material/styles';

export const gridTheme: Components<Theme>['MuiGrid'] = {
  // styleOverrides: {},
  // variants: [],
};
